export const isBetweenZeroAndOneHundred = (num: number) => {
  return num >= 0 && num <= 100;
};

export type isValidRangeTypes = {
  min: number;
  max: number;
};

export const RANGE_INPUTS = {
  MIN: 'min',
  MAX: 'max',
};

export const isValidRange = ({ min, max }: isValidRangeTypes) => {
  if ((!isBetweenZeroAndOneHundred(min) && !isBetweenZeroAndOneHundred(max)) || min === max) {
    return { errorType: [RANGE_INPUTS.MIN, RANGE_INPUTS.MAX], isValid: false };
  } else if (!isBetweenZeroAndOneHundred(min)) {
    return { errorType: [RANGE_INPUTS.MIN], isValid: false };
  } else if (!isBetweenZeroAndOneHundred(max)) {
    return { errorType: [RANGE_INPUTS.MAX], isValid: false };
  } else if (max < min) {
    return { errorType: [RANGE_INPUTS.MIN], isValid: false };
  }

  return { errorType: [], isValid: true };
};
